module.exports = __webpack_public_path__ + "static/img/order-help.2c2f7f64.png";